import Map from '@/components/form/Map';
import Input from '@/components/form/Input';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { useFormContext } from 'react-hook-form';

import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import Select from '@/components/form/Select';

import { useActivities } from '@/data/activity';
import { useRegions } from '@/data/region';

const FormGeneral = () => {
  const form = useFormContext();
  const activities = useActivities();
  const regions = useRegions();

  if (activities.isLoading || !activities.data) {
    return null;
  }
  if (regions.isLoading || !regions.data) {
    return null;
  }

  return (
    <>
      <div className="flex justify-center mb-6">
        <div className="flex-1 z-0">
          <Map />
        </div>
      </div>
      <Input name="name" label="Location Name" autoComplete="off" />
      <Select
        label="Region"
        name="regionId"
        options={getRegionOptions(regions.data)}
      />
      <Input name="address" label="Address (optional)" autoComplete="off" />
      <div>
        <Label className="font-semibold">Activities</Label>
        <p className="text-sm text-muted-foreground">
          Activities that can be coached at this location:
        </p>
        <div className="grid gap-2 mt-2">
          <FormField
            control={form.control}
            name="activities"
            render={() => (
              <FormItem>
                {activities.data.map((activity) => (
                  <FormField
                    key={activity.id}
                    control={form.control}
                    name="activities"
                    render={({ field }) => {
                      return (
                        <FormItem
                          key={activity.id}
                          className="flex flex-row items-center space-x-3 space-y-0 mb-2"
                        >
                          <FormControl>
                            <Checkbox
                              checked={field.value?.includes(activity.id)}
                              onCheckedChange={(checked) => {
                                return checked
                                  ? field.onChange([
                                      ...field.value,
                                      activity.id
                                    ])
                                  : field.onChange(
                                      field.value?.filter(
                                        (value) => value !== activity.id
                                      )
                                    );
                              }}
                            />
                          </FormControl>
                          <div className="leading-tight block">
                            <FormLabel className="">{activity.title}</FormLabel>
                          </div>
                        </FormItem>
                      );
                    }}
                  />
                ))}
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    </>
  );
};

function getRegionOptions(regions) {
  return regions.map((region) => ({
    key: region.id,
    value: region.id,
    label: region.name
  }));
}

export default FormGeneral;
